// 한글 이름 맞추기. 사람은 이름을 **치는 중에도** 찾는다 — 한글 입력기는 `이` 를 치는 동안 `ㅇ` 을
// 먼저 내놓고, `한` 을 치는 동안 `하` 를 내놓는다. 그 순간 목록이 비었다가 다시 서면 깜빡임이다.
// 그리고 초성만(`ㅇㅎㄴ` → 이하늘) 치는 것은 카톡·전화번호부에서 익은 손버릇이다.

const FIRST = 'ㄱㄲㄴㄷㄸㄹㅁㅂㅃㅅㅆㅇㅈㅉㅊㅋㅌㅍㅎ'

/** 한글 음절의 번호(가 = 0). 음절이 아니면 -1. */
const syllable = (c: string) => {
  const k = c.charCodeAt(0) - 0xac00
  return k >= 0 && k < 11172 ? k : -1
}

/** 친 글자 `q` 가 이름의 글자 `n` 자리에 맞는가. `tail` 이면 아직 치는 중인 마지막 글자다. */
function fits(q: string, n: string, tail: boolean): boolean {
  const c = syllable(n)
  const k = syllable(q)
  return (
    q === n ||
    // 초성만 — 어느 자리든(`ㅇㅎㄴ`, `이ㅎ`).
    (c >= 0 && FIRST.indexOf(q) === Math.floor(c / 588)) ||
    // 받침 없이 친 마지막 글자는 받침이 붙을 글자와 맞는다(`하` → `한`).
    (tail && c >= 0 && k >= 0 && k % 28 === 0 && c - (c % 28) === k)
  )
}

/** `needle` 이 `name` 의 어디서 맞는가(대소문자 무시). 안 맞으면 -1. 빈 글자는 0. */
export function hangul_at(name: string, needle: string): number {
  const h = name.toLowerCase()
  const q = needle.toLowerCase()
  for (let at = 0; at + q.length <= h.length; at += 1) {
    let ok = true
    for (let i = 0; i < q.length && ok; i += 1) {
      ok = fits(q[i] as string, h[at + i] as string, i === q.length - 1)
    }
    if (ok) return at
  }
  return -1
}
